var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cropper-content"},[_c('div',{staticClass:"cropper",staticStyle:{"text-align":"center"}},[_c('cropper',{attrs:{"imgurl":_vm.tailorimg},on:{"upload_success":_vm.onMobileCoverImageUploadSuccess}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }